<template>
  <div :class="{ 'loader-cover': startupFetchInProgress }">
    <StartupProfilePage
      v-show="startup.name"
      :can-user-see-private-data="true"
    />
    <NoProject v-show="!startupFetchInProgress && !startup.name" />
  </div>
</template>

<script>
import StartupProfilePage from '@/modules/startup-profile/StartupProfilePage'
import NoProject from '@/modules/startup-profile/NoProject'
import { mapState } from 'vuex'
import http from '@/services/http'

export default {
  components: { StartupProfilePage, NoProject },
  props: {
    startupId: {
      type: [String, Number],
      default: '',
    },
    linkId: {
      type: [String, Number],
      default: '',
    },
  },
  computed: mapState({
    startup: (state) => state.startupProfile.startup,
    startupFetchInProgress: (state) => state.startupProfile.fetchInProgress,
    userHasAuthToken: (state) => state.user.hasAuthToken,
  }),

  async created() {
    const startupId = this.startupId
    const linkId = this.linkId
    const showroomId = this.$route.query.showroomId

    const userResponse = this.$store.dispatch('user/fetchNoRedirect')
    const startupResponse = await this.$store.dispatch(
      'startupProfile/fetchPrivate',
      { startupId, linkId, showroomId },
    )
    http.post(`/startups/${startupId}/private/${linkId}/visit`)

    const investor = await this.$store.dispatch(
      'startupProfileInvestorClassifies/getInvestorByLink',
      {
        startupId,
        linkId,
      },
    )
    if (investor) {
      this.$store.commit(
        'startupProfileInvestorClassifies/enableClassification',
      )
      if (investor.state === 'applied' || !investor.state) {
        this.$store.dispatch(
          'startupProfileInvestorClassifies/startScreening',
          { startupId, linkId, investorId: investor.id },
        )
      }
    }
  },
}
</script>
